module.exports = __webpack_public_path__ + "static/img/A111.0e10bad0.jpg";